import Vue from 'vue'
import Router from 'vue-router'
import VueAnalytics from 'vue-analytics'
import Landing from '@/components/Views/LandingPage'
import NotFound from '@/components/GeneralViews/NotFoundPage'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      component: NotFound
    },
    {
      path: '/',
      name: 'Landing',
      component: Landing
    }
  ]
})

Vue.use(VueAnalytics, {
  id: 'UA-113655402-1',
  linkers: ['www.beefstats.com.br', 'app.beefstats.com.br'],
  router,
  autoTracking: {
    transformQueryString: false
  },
  debug: {
    enabled: false
  }
})

Vue.use(VueAnalytics, {
  id: 'AW-797199010'
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js